import { useEffect, useState } from 'react'
import { api, WorkloadEntry } from '../api/projects'

function WorkloadView() {
  const [workload, setWorkload] = useState<WorkloadEntry[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    api.getWorkload()
      .then(setWorkload)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <div>Loading workload...</div>
  if (error) return <div style={{ color: 'red' }}>Error: {error}</div>

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Engineer Workload</h2>
      {workload.length === 0 && <p>No engineers found.</p>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {workload.map((e) => (
          <div
            key={e.id}
            style={{
              border: '1px solid #ccc',
              borderRadius: '8px',
              padding: '1rem',
              background: '#fafafa',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0 }}>{e.name}</h3>
              <span
                style={{
                  padding: '0.25rem 0.5rem',
                  borderRadius: '999px',
                  fontSize: '0.8rem',
                  background: e.active_projects.length > 3 ? '#f8d7da' : '#d4edda',
                  color: e.active_projects.length > 3 ? '#721c24' : '#155724',
                }}
              >
                {e.active_projects.length} active
              </span>
            </div>
            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginTop: '0.5rem' }}>
              {e.active_projects.map((p) => (
                <span
                  key={p.id}
                  style={{
                    padding: '0.25rem 0.5rem',
                    borderRadius: '4px',
                    fontSize: '0.8rem',
                    background: '#e0f2fe',
                    color: '#0369a1',
                  }}
                >
                  {p.name} {p.role && `(${p.role})`}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default WorkloadView
